import { useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Invoices from "./scenes/invoices";
import Contacts from "./scenes/contacts";
import Bar from "./scenes/bar";
import Form from "./scenes/form";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Geography from "./scenes/geography";
import Calendar from "./scenes/calendar/calendar";
import LoginPage from "./scenes/login/loginpage";
import Pgmanage from "./scenes/pgmanage/pgmanage";
import Seed from "./scenes/Farmseed/seed"; 
import Details from "./scenes/cropDetails/Details";
import Consents from "./scenes/farmconsents/Consents";
import Cropmanagement from "./scenes/cropmanagement/cropmanage";

import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import State from "./scenes/state/statedata";
import Dist from "./scenes/dist/distdata";
import Block from "./scenes/block/blockdata";
import Village from "./scenes/village/villagedata";
import Gp from "./scenes/gp/gpdata";
import Caste from "./scenes/caste/castedata";
import PGH from "./scenes/PGH/producergroupheads";
import ProducerGroup from "./scenes/ProducerGroup/producergroup";
import Pgseedmap from "./scenes/PGSeedMap/pgseedmap";
import Userrole from "./scenes/UserRole/userrole";
import User from "./scenes/User/user";
import FarmMange from "./scenes/FarmerManagement/farmermanage";
import CropPlan from "./scenes/cropplancreate/CropPlan";
import Fpc from "./scenes/farmerPC/fpc";
import Croproduction from "./scenes/croproduction/cropproduction";
import Tlseed from "./scenes/Tlseedproduction/tlseed";
import Marketlink from "./scenes/marketlinkage/marketlinkage";
import Cropcutting from "./scenes/cropcutting/cropcutting";
import Eventandactivity from "./scenes/eventandactivity/even&activity";
import Mip from "./scenes/MIP/mipdata";
import Plans from "./scenes/Plan-Crop/plans"; 
import AddMarketLink from "./scenes/AddMarketLinkage/addMarketLinkage";
import AddCropProduction from "./scenes/AddcropProduction/addcropproduction";
import Addfpc from "./scenes/AddFpc/addfpc";
import Editplans from "./scenes/EditPlans/editplans";
import Addplans from "./scenes/addplans/addplan";
import AddCuttingDetails from "./scenes/AddcuttingDetails/addcuttingdetails";
import ChildProduction from "./scenes/ChildProduction/childproduction";
import ChildMarket from "./scenes/ChildMarket/childmarket";
import AddFarmer from "./scenes/AddFarmer/addfarmer";

import AddTlOutreach from "./scenes/addTlOutreach/addtloutreach";
import GoalsAndArchives from "./scenes/GoalsandArchives/goalsandarchives";
import Reports from "./scenes/Reports/reports";
import ImageVerification from "./scenes/ImageVerification/imageverificaion";
import CapacityBuilding from "./scenes/CapacityBuilding/capacitybuild";
import FFD from "./scenes/FFD/ffd";
import ChildFFD from "./scenes/ChildFFD/childffd";
import Childcapacitybuild from "./scenes/childCapacitybuild/childcapacitybuild";
import UpdateFpc from "./scenes/AddFpc/updateFpc";
import Addcapacitybuilding from "./scenes/addcapacitybuild/addcapacitybuild";
import AddPgData from "./scenes/ProducerGroup/addPgdata";

import AddFarmerfields from "./scenes/FFD/addffd";
import TechnologyPark from "./scenes/TechnologyPark/technologypark";
import AddTechnologyPark from "./scenes/TechnologyPark/addtechnologypark";
import Edittechnologypark from "./scenes/TechnologyPark/editffdpage";
import UserRoleInd from "./scenes/UserRole/userroleind";
import AddUserRole from "./scenes/UserRole/AddUserRole";
import AddUser from "./scenes/User/AddUser";
import EditUser from "./scenes/User/EditUser";
import ChildTechnologyPark from "./scenes/TechnologyPark/childtechnologypark";
import SeedData from "./scenes/SeedData/seeddata";
import SeedVariety from "./scenes/SeedVariety/seedvariety";
import SuppliesManagement from "./scenes/SuppliesManagement/suppliesmanagement";
import PaniPanchayat from "./scenes/PaniPanchayat/PaniPanchayat";
import GovtDashboard from "./scenes/NewPages/GovtDashboard";
import Target from "./scenes/Targets/Target";
function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const location = useLocation();

  const isAuthenticated = localStorage.getItem("token");

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {location.pathname !== "/login" && location.pathname !== "/govtdashboard" && <Sidebar isSidebar={isSidebar} />}
          <main className="content">
            {/* {location.pathname !== "/login" && <Topbar setIsSidebar={setIsSidebar} />} */}
            <Routes>
              <Route path="/" element={<Navigate to="/login" />} />
              <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" /> : <LoginPage />} />
              <Route path="/govtdashboard" element={<GovtDashboard />} />
              {/* Protected routes */}
              <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" />} />
              <Route path="/team" element={isAuthenticated ? <Team /> : <Navigate to="/login" />} />
              <Route path="/contacts" element={isAuthenticated ? <Contacts /> : <Navigate to="/login" />} />
              <Route path="/invoices" element={isAuthenticated ? <Invoices /> : <Navigate to="/login" />} />
              <Route path="/form" element={isAuthenticated ? <Form /> : <Navigate to="/login" />} />
              <Route path="/bar" element={isAuthenticated ? <Bar /> : <Navigate to="/login" />} />
              <Route path="/pie" element={isAuthenticated ? <Pie /> : <Navigate to="/login" />} />
              <Route path="/line" element={isAuthenticated ? <Line /> : <Navigate to="/login" />} />
              <Route path="/faq" element={isAuthenticated ? <FAQ /> : <Navigate to="/login" />} />
              <Route path="/calendar" element={isAuthenticated ? <Calendar /> : <Navigate to="/login" />} />
              <Route path="/geography" element={isAuthenticated ? <Geography /> : <Navigate to="/login" />} />

              <Route path="/seed" element={isAuthenticated ? <Seed /> : <Navigate to="/login" />} />
              <Route path="/details" element={isAuthenticated ? <Details /> : <Navigate to="/login" />} />
              <Route path="/consents" element={isAuthenticated ? <Consents /> : <Navigate to="/login" />} />
              <Route path="/pgmanage" element={isAuthenticated ? <Pgmanage /> : <Navigate to="/login" />} />
              <Route path="/cropmanagement" element={isAuthenticated ? <Cropmanagement /> : <Navigate to="/login" />} />

              <Route path="/statedata" element={isAuthenticated ? <State /> : <Navigate to="/login" />} />
              <Route path="/distdata" element={isAuthenticated ? <Dist /> : <Navigate to="/login" />} />
              <Route path="/blockdata" element={isAuthenticated ? <Block /> : <Navigate to="/login" />} />
              <Route path="/villagedata" element={isAuthenticated ? <Village /> : <Navigate to="/login" />} />
              <Route path="/gpdata" element={isAuthenticated ? <Gp /> : <Navigate to="/login" />} />
              <Route path="/castedata" element={isAuthenticated ? <Caste /> : <Navigate to="/login" />} />
              <Route path="/producergroupheads" element={isAuthenticated ? <PGH /> : <Navigate to="/login" />} />
              <Route path="/producergroup" element={isAuthenticated ? <ProducerGroup /> : <Navigate to="/login" />} />
              <Route path="/pgseedmap" element={isAuthenticated ? <Pgseedmap /> : <Navigate to="/login" />} />

              <Route path="/userRole" element={isAuthenticated ? <Userrole /> : <Navigate to="/login" />} />
              <Route path="/userroleind/:userRoleId" element={isAuthenticated ? <UserRoleInd /> : <Navigate to="/login" />} />
              <Route path="/adduserrole" element={isAuthenticated ? <AddUserRole /> : <Navigate to="/login" />} />
              <Route path="/userdata" element={isAuthenticated ? <User /> : <Navigate to="/login" />} />
              <Route path="/adduser" element={isAuthenticated ? <AddUser /> : <Navigate to="/login" />} />
              <Route path="/edituser/:userId" element={isAuthenticated ? <EditUser /> : <Navigate to="/login" />} />
              <Route path="/farmermanage" element={isAuthenticated ? <FarmMange /> : <Navigate to="/login" />} />
              <Route path="/add-crop" element={isAuthenticated ? <CropPlan /> : <Navigate to="/login" />} />
              <Route path="/farmerproducercompany" element={isAuthenticated ? <Fpc /> : <Navigate to="/login" />} />
              <Route path="/cropproduction" element={isAuthenticated ? <Croproduction /> : <Navigate to="/login" />} />
              <Route path="/tlseed" element={isAuthenticated ? <Tlseed /> : <Navigate to="/login" />} />
              <Route path="/marketlinkage" element={isAuthenticated ? <Marketlink /> : <Navigate to="/login" />} />
              <Route path="/cropcutting" element={isAuthenticated ? <Cropcutting /> : <Navigate to="/login" />} />
              <Route path="/eventandactivity" element={isAuthenticated ? <Eventandactivity /> : <Navigate to="/login" />} />
              <Route path="/mipdata" element={isAuthenticated ? <Mip /> : <Navigate to="/login" />} />
              <Route path="/plans" element={isAuthenticated ? <Plans /> : <Navigate to="/login" />} />
              <Route path="/addMarketLinkage" element={isAuthenticated ? <AddMarketLink /> : <Navigate to="/login" />} />

              <Route path="/addCropProduction" element={isAuthenticated ? <AddCropProduction /> : <Navigate to="/login" />} />
              <Route path="/addfpc" element={isAuthenticated ? <Addfpc /> : <Navigate to="/login" />} />
              <Route path="/editplans" element={isAuthenticated ? <Editplans /> : <Navigate to="/login" />} />
              <Route path="/addplan" element={isAuthenticated ? <Addplans /> : <Navigate to="/login" />} />
              <Route path="/addcuttingdetails" element={isAuthenticated ? <AddCuttingDetails /> : <Navigate to="/login" />} />  
              <Route path="/childproduction" element={isAuthenticated ? <ChildProduction /> : <Navigate to="/login" />} />
              <Route path="/childmarket" element={isAuthenticated ? <ChildMarket /> : <Navigate to="/login" />} />
              <Route path="/addtloutreach" element={isAuthenticated ? <AddTlOutreach /> : <Navigate to="/login" />} />
              <Route path="/addFarmer" element={isAuthenticated ? <AddFarmer /> : <Navigate to="/login" />} />
              <Route path="/goalsandarchives" element={isAuthenticated ? <GoalsAndArchives /> : <Navigate to="/login" />} />
              <Route path="/reports" element={isAuthenticated ? <Reports /> : <Navigate to="/login" />} />
              <Route path="/imageVerification" element={isAuthenticated ? <ImageVerification /> : <Navigate to="/login" />} />
              <Route path="/capacitybuilding" element={isAuthenticated ? <CapacityBuilding /> : <Navigate to="/login" />} />
              <Route path="/ffd" element={isAuthenticated ? <FFD /> : <Navigate to="/login" />} />
              <Route path="/childffd" element={isAuthenticated ? <ChildFFD /> : <Navigate to="/login" />} />
              <Route path="/childcapacitybuild" element={isAuthenticated ? <Childcapacitybuild /> : <Navigate to="/login" />} />
              <Route path="/updateFpc" element={isAuthenticated ? <UpdateFpc /> : <Navigate to="/login" />} />
              <Route path="/addcapacitybuild" element={isAuthenticated ? <Addcapacitybuilding /> : <Navigate to="/login" />} />
              <Route path="/addPgdata" element={isAuthenticated ? <AddPgData /> : <Navigate to="/login" />} />
              <Route path="/addffd" element={isAuthenticated ? <AddFarmerfields /> : <Navigate to="/login" />} />
              <Route path="/technologypark" element={isAuthenticated ? <TechnologyPark /> : <Navigate to="/login" />} />
              <Route path="/addtechnologypark" element={isAuthenticated ? <AddTechnologyPark /> : <Navigate to="/login" />} />
              <Route path="/editffdpage" element={isAuthenticated ? <Edittechnologypark /> : <Navigate to="/login" />} />
              <Route path="/childtechnologypark" element={isAuthenticated ? <ChildTechnologyPark /> : <Navigate to="/login" />} />
              <Route path="/seeddata" element={isAuthenticated ? <SeedData /> : <Navigate to="/login" />} />
              <Route path="/seedvariety" element={isAuthenticated ? <SeedVariety /> : <Navigate to="/login" />} />
              <Route path ="/suppliesmanagement" element={isAuthenticated ? <SuppliesManagement /> : <Navigate to="/login" />} />
              <Route path ="/panipanchayat" element={isAuthenticated ? <PaniPanchayat /> : <Navigate to="/login" />} />
                            <Route path ="/target" element={isAuthenticated ? <Target /> : <Navigate to="/login" />} />

            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
